module.exports = __webpack_public_path__ + "img/opp-qflp.5f249b8a.jpg";